import cuid from 'cuid'

export default () => (
  cuid().padEnd(26, '0')
)
